import React from 'react';
import clsx from 'clsx';
import TableWrapper from '@/components/table/TableWrapper';

const DatasetSettingsTable = ({ children, className }) => (
  <TableWrapper
    unstackable
    compact
    solid
    sticky
    className={clsx('aridhia-table-wrapper aridhia-dataset-settings-table', className)}
  >
    {children}
  </TableWrapper>
);
export default DatasetSettingsTable;
